export function valueExistsInArray<T>(
  value: unknown,
  array: readonly T[] | T[],
): value is T {
  return array.some(item => item === value);
}
